import {
  Autocomplete,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

import { rankItem } from "@tanstack/match-sorter-utils";

import HeadCell from "tables/HeadCell";
import BodyCell from "tables/BodyCell";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDPagination from "components/MDPagination";
import MDBox from "components/MDBox";
import { useEffect, useMemo, useState } from "react";
import {
  DebouncedInput,
  StyledTableFilterCell,
  StyledTableRow,
  TableBodyCell,
  TableBody_,
  TableHead_,
  TableHeaderCell,
} from "./components/table";
import { SetPage } from "./components/pagination";

const fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);
  addMeta({ itemRank });
  return itemRank.passed;
};

function FilterInput({ column, table }) {
  const columnFilterValue = column.getFilterValue();

  return (
    <DebouncedInput
      type="text"
      name={column.id}
      value={columnFilterValue ?? ""}
      onChange={(v) => column.setFilterValue(v)}
    />
  );
}

function ServerTable({
  data: tableData,
  columns: tableColumns,
  pagination,
  setPagination,
  columnFilters,
  setColumnFilters,

  sorting,
  setSorting,
  dataInfo,
  onSelectedRowsChange = null,
}) {
  //const [columnFilters, setColumnFilters] = useState([]);
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, [tableColumns]);
  const [rowSelection, setRowSelection] = useState({});
  //const[sorting,setSorting]=useState([])

  const table = useReactTable({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    pageCount: dataInfo ? dataInfo.pageCount + 1 : 0,
    getCoreRowModel: getCoreRowModel(),
    //getPaginationRowModel: getPaginationRowModel(),
    //getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onPaginationChange: setPagination,
    manualPagination: true,
    manualFiltering: true,

    manualSorting: true,
    onColumnFiltersChange: setColumnFilters,
    onSortingChange: setSorting,
    onRowSelectionChange: setRowSelection,
    state: {
      pagination,
      columnFilters,
      sorting,
      rowSelection,
    },
  });
  useEffect(() => {
    if (onSelectedRowsChange !== null) {
      onSelectedRowsChange(table.getSelectedRowModel().flatRows.map((row) => row.original));
    }
  }, [rowSelection, table, onSelectedRowsChange]);
  useEffect(() => {
    setRowSelection({});
  }, [data]);
  const { pageIndex, pageSize } = table.getState().pagination;
  const { getPageCount, getCanPreviousPage, getCanNextPage, setPageIndex, setPageSize } = table;
  const showTotalEntries = true;
  const totalData = dataInfo?.totalRecord;
  //const totalData = table.getPrePaginationRowModel()?.rows.length;
  const entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;
  let entriesEnd;
  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === getPageCount() - 1) {
    entriesEnd = totalData;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }
  const pageOptions = [...Array(getPageCount())].map((x, index) => index);
  const renderPagination = pageOptions.map((x) => (
    <MDPagination
      item
      key={x}
      active={pageIndex === x}
      onClick={() => {
        setPageIndex(x);
      }}
    >
      {x + 1}
    </MDPagination>
  ));
  const customizedPageOptions = pageOptions.map((x) => x + 1);
  const handleInputPagination = ({ target: { value } }) => {
    value > pageOptions.length || value < 0 ? setPageIndex(0) : setPageIndex(Number(value));
  };
  const handleInputPaginationValue = ({ target: { value } }) => {
    setPageIndex(Number(value));
  };
  const height = table.getRowModel().rows.length === 0 ? "0" : "545px"
  return (
    <>
      <TableContainer sx={{ borderRadius: ".25rem", border: "1px solid #c9c9c9",height:height,backgroundColor:"inherit", }}>
        {/* <MDBox display="flex" justifyContent="space-between" alignItems="center" padding="1rem 0">
          <SetPage pageSize={pageSize} onChange={(e, value) => setPageSize(value, 10)} />
        </MDBox> */}
        <Table>
          {/* <TableHead sx={{ display: "table-header-group" }}>
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  // <HeadCell width="auto" align="left" sorted="asce" key={header.id}>
                  //   {flexRender(header.column.columnDef.header, header.getContext())}
                  // </HeadCell>
                  <TableHeaderCell
                    onClick={header.column.getToggleSortingHandler()}
                    isSorted={header.column.getIsSorted()}
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </TableHeaderCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody>
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow sx={{ backgroundColor: "aliceblue" }} key={headerGroup.id}>
                {headerGroup.headers.map((header, i) => (
                  <>
                    {header.column.getCanFilter() ? (
                      <StyledTableFilterCell key={header.id}>
                        <FilterInput column={header.column} table={table} />
                      </StyledTableFilterCell>
                    ) : (
                      <StyledTableFilterCell key={header.id}></StyledTableFilterCell>
                    )}
                  </>
                ))}
              </TableRow>
            ))}
            {table.getRowModel().rows.map((row) => (
              <StyledTableRow key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  // <BodyCell noBorder={false} align="left" key={cell.id}>
                  //   {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  // </BodyCell>
                  <TableBodyCell>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableBodyCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody> */}
          <TableHead_ table={table} />
          <TableBody_ table={table} />
        </Table>
         
      </TableContainer>
      <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          sx={{background:"white"}}
          p={!showTotalEntries && pageOptions.length === 1 ? 0 : 1.5}
        >
          {showTotalEntries && (
            <MDBox mb={{ xs: 3, sm: 0 }}>
              <MDTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {totalData} entries
              </MDTypography>
            </MDBox>
          )}
          {pageOptions.length > 1 && (
            <MDPagination variant="gradient" color="info">
              {getCanPreviousPage() && (
                <MDPagination item onClick={() => setPageIndex(pageIndex - 1)}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                </MDPagination>
              )}
              {renderPagination.length > 6 ? (
                <MDBox width="5rem" mx={1}>
                  <MDInput
                    inputProps={{ type: "number", min: 1, max: customizedPageOptions.length }}
                    value={customizedPageOptions[pageIndex]}
                    onChange={(handleInputPagination, handleInputPaginationValue)}
                  />
                </MDBox>
              ) : (
                renderPagination
              )}
              {getCanNextPage() && (
                <MDPagination item onClick={() => setPageIndex(pageIndex + 1)}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                </MDPagination>
              )}
            </MDPagination>
          )}
        </MDBox>
    </>
  );
}

export default ServerTable;
